import { useState } from 'react';
import { QueryResponse, AIQueryHook } from './types';
import { makeRemotePostQuery } from '../../../main/factories/usecases';
import { AIProvider, AIProviders, AIQueryType, AIQueryTypes } from '@hone-automation/common';
import { useParams } from 'react-router-dom';

// Custom hook for single-shot queries
export const useAIQuery = (): AIQueryHook => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [response, setResponse] = useState<QueryResponse | null>(null);
  const { locationId } = useParams();

  const sendQuery = async (
    message: string,
    type: AIQueryType = AIQueryTypes.Other,
    provider: AIProvider = AIProviders.OpenAI,
    model: string = 'gpt-4o-mini'
  ): Promise<QueryResponse> => {
    setLoading(true);
    setError(null);

    try {
      const data = await makeRemotePostQuery().postQuery({ message, type, locationId, provider, model });
      setResponse(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    sendQuery,
    loading,
    error,
    response,
    clearError: () => setError(null),
    clearResponse: () => setResponse(null),
  };
};
